<ng-container *transloco="let t;">

    <input class="form-control hidden"
           #chooseFileInput
           (change)="onFileChanged($event)" type="file">
    <span class="form-control p-0">
        <button type="button" class="px-1 choose-file-button" (click)="chooseFileInput.click()">{{ t('Branding - choose image component - choose file button') }}</button>
    <span class="p-1">
    @if (icon && fileName) {
        {{ fileName }}

    } @else {
        {{ t('Branding - choose image component - no file selected') }}
    }
    </span>
    <span>
        <span *ngIf="!icon">
            <i data-feather="image" class="cursor-pointer lighten-2 text-secondary favIconPreviewbefore"></i>
        </span>
        <img [src]="icon | getImage" class="favIconPreviewafter {{ icon ? '' : 'd-none'}}"  alt="fav icon">
    </span>

</span>
</ng-container>